module.exports = __webpack_public_path__ + "img/ic_cross_close.f1a5ef61.svg";